const dealerRoles = [
    "Dealer",
    "Manager",
    "Manager II",
    "Company Manager"
]

export default dealerRoles